import { userInfoMapperSocket } from 'components/containers/utils/sockets/userInfoMapperSocket';
import { User } from 'models/User';
import React, { useRef, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import SocketContext from 'socket-context';
import { RootState } from 'store';
import { gdModalType, gdSubtype, socketMessageType } from 'types/Constants';
import { validateAndCreateSocketIfExist } from 'utils/SocketValidator';
import { Box, Flex, Text, Button, Theme } from '@radix-ui/themes';
import { socketContextType } from 'index';
import RoomClient from 'components/containers/utils/mediaSoup/RoomClient';
import exitPresentation from "../../../assets/images/exitPresentation.png";
import groupDiscussion from "../../../assets/images/groupDiscussion.png";
import { Consumer } from 'mediasoup-client/lib/types';
import ImageComponent from 'components/classroom/components/ImageComponent';
import TraineeDraggableCard from 'components/classroom/components/TraineeDraggableCard';
import Draggable from 'react-draggable';
import GdReadyToPresent from './ReadyToPresent';
import GdStartPresenter from './GdStartPresenter';
import GdCompletePreparation from './GdCompletePreparation';
import GdWait from './GdWait';
import GdCommence from './GdCommence';
import GdEndWait from './GdEndWait';
import GDGroupleader from './GdGroupLeader';
import GdRandomlySelected from './GdRandomlySelected';
import AsktoPresent from './AskToPresent';
import GdPresentationRankOrder from './GdPresentationRankOrder';
import TableElement from 'components/classroom/components/TableElement';
import Participant from 'components/classroom/components/backup/Participant';
import GdOpenClassInteraction from './GdOpenClassInteraction';
import Trainer from 'components/classroom/components/backup/Trainer';
import PeerView from 'components/classroom/components/Peers/PeerView';
import MyPeerView from 'components/classroom/components/Peers/MyPeerView';
import BottomMessage from './BottomMessage';
import BottomMessageWithIcon from './BottomMessageWithIcon';
import plussquare from "../../../assets/images/plussquare.png";
import maximize from "../../../assets/images/maximize.png";
import mico from "../../../assets/images/mico.png";
import minus from "../../../assets/images/minus.png";
import ConfRoom from './ConfRoom';
import { updateLiveStreamSettings } from 'store/reducers/livestreamSettings';
import { gdGroupDiscussionParticipants } from 'store/reducers/countReducer';
import { UserInfoMapperSocketHandler } from 'utils/UserInfoMapper';
import TableElementNew from 'components/classroom/components/TableElementNew';
import OpenClassInteraction from 'components/classroom/components/backup/OpenClassInteraction';
import { debounce } from 'lodash';

export const nominationType = {
  SYSTEM: 'Viliyo',
  GROUP_MEMBERS: 'Group',
  GROUP_LEADER: 'GroupLeader',
  TRAINER: 'Trainer',
}
interface gdProps {
  sessionId: any;
  roomClient?: RoomClient | null;
  messageCount: any;
  instructorPresentorData: any;
  alter: any;
  onBrief: (val: any) => void,
};

const GroupDiscussion: React.FC<gdProps> = ({ roomClient, sessionId, messageCount, instructorPresentorData, alter, onBrief }) => {
  const dispatch = useDispatch();
  let userInfoHandler = useRef<UserInfoMapperSocketHandler>();
  const session_id = useSelector((state: RootState) => state?.live.settings.roomId);
  const socketList: socketContextType[] = useContext(SocketContext);
  const profileData = useSelector((state: RootState) => state?.auth?.user as User);
  const batchData = useSelector((state: RootState) => state.live.settings?.batch);
  const consumers = useSelector((state: RootState) => state.live.settings.consumers);
  const producers = useSelector((state: RootState) => state.live.settings.producers);
  const shareConsumer: any = Object.values(consumers || {}).find((consumer: any) => consumer.appData?.share === true);
  const allGroup = useSelector((state: RootState) => state?.session?.allGroup);
  const gdSelectedTraineeForPresentation: any = useSelector(
    (state: RootState) => state.countReducer?.gdSelectedTraineeForPresentation
  );
  const { trainer } = useSelector((state: RootState) => state.live.settings);

  const [modalMode, setModalMode] = useState<any>(gdModalType.SETUP);
  const [openClassInteraction, setOpenClassInteraction] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [tblData, setTblData] = useState<any>({});
  const [groupLeaderDetails, setGroupLeaderDetails] = useState<any>();
  const [newTblData, setNewTblData] = useState<any[]>([]);
  const [tblDataSnap, setTblDataSnap] = useState<any>({});
  const [groupleader, setGroupleader] = useState<any>();
  const [groupOrder, setGroupOrder] = useState<any[]>([]);
  const [briefMode, setBriefMode] = useState<string>('');
  const [canTransfer, setCanTransfer] = useState(true);
  const [onlineStream, setOnlineStream] = useState<any[]>([]);
  const [manuallySelected, setManuallySelected] = useState<any>();
  const [presentationOrder, setPresentationOrder] = useState({
    groupName: '',
    rankOrder: '',
    traineeDetails: {},
    isOurGroupIsGoingToRepresent: false,
  } as any);
  const [myStream, setMyStream] = useState<any>({});
  const [otherStream, setOtherStream] = useState<any>({});
  const [allStream, setAllStream] = useState<any>({});
  const [showStartPresentation, setShowStartPresentation] = useState(false);
  const [isPresentationStarted, setIsPresentationStarted] = useState(false);
  const [presentaionData, setPresentaionData] = useState<{
    presentNominee: string;
    activePresentation: string;
    fileUrl: string;
    myGroups: any[];
  }>({} as any);
  const [randomlySelected, setRandomlySelected] = useState({});
  const [GLMmode, setGLMmode] = useState<string>('');
  const [isGlTransfer, setIsGlTransfer] = useState(false);
  const [unspotlight, setUnspotlight] = useState<boolean>(false);
  const [shareStream, setShareStream] = useState({ toURL: () => { } });
  const [messageCxt, setMessageCxt] = useState<{ visible: boolean; message: string }>({ visible: false, message: '' });
  const [showFullscreen, setShowFullscreen] = useState(false);
  const [presentaionType, setPresentaionType] = useState('');
  const [fileToPresent, setFileToPresent] = useState('');
  const [showMenu, setShowMenu] = useState(false);
  const [isExpandedTabel, setIsExpandedTabel] = useState(false);
  const [amImute, setAmImute] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isUserFeedHidden, setIsUserFeedHidden] = useState(false);
  const [isOurGroupRepresenting, setIsOurGroupRepresenting] = useState(false);
  const [groupTable, setGroupTable] = useState({});
  const [hardCopyModifiedGroupTableData, setHardCopyModifiedGroupTableData] = useState({});
  const [isIamRepresentingGroup, setIsIamRepresentingGroup] = useState(false);
  const [selectedView, setSelectedView] = useState(0);
  const [removedEmail, setRemovedEmail] = useState('');
  const [hideOurDraggableView, setHideOurDraggableView] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const [isTwoMinutesLeft, setIsTwoMinutesLeft] = useState(false);
  const [myEmailInPresentation, setMyEmailInPresentation] = useState({ participant_email: 'no email' });
  const [extendedTime, setExtendedTime] = useState({ visible: false, time: 0 });
  const [layoutHeight, setLayoutHeight] = useState(0);
  const [boxSize, setBoxSize] = useState({ height: 0, width: 0 } as any);
  const dropoutState = useSelector((state: any) => state.countReducer?.response);
  const [isTrainerPresent, setIsTrainerPresent] = useState({});
  const [GDActivityData, setGDActivityData] = useState<any>({});
  const [GDAlotTime, setGDAlotTime] = useState(0);
  const lastExtendTimeIdRef = useRef(null);
  const [pminutes, setPMinutes] = useState(3); // Default 3 minutes for presentation
  const [pseconds, setPSeconds] = useState(0);
  const presentationExtendTimeIdRef = useRef(null);
  const groupleaderRef = useRef<any>();
  groupleaderRef.current = groupleader;
  const tblDataRef = useRef<any>();
  tblDataRef.current = tblData;
  const gdActivityRef = useRef<any>(null);

  // Ref for measuring Box dimensions
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return () => {
      dispatch(updateLiveStreamSettings({ groupLeaderNew: [] }));
    };
  }, []);


  useEffect(() => {
    if (batchData) {
      const newData = JSON.parse(batchData.sittingStyle[0].table);
      setNewTblData(newData);
    }
  }, [batchData]);

  useEffect(() => {
    if (timeLeft === null) return;
    const interval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime === null || prevTime <= 0) {
          clearInterval(interval);
          return null;
        }
        if (prevTime === 120) {
          setIsTwoMinutesLeft(true);
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  useEffect(() => {
    if (isTwoMinutesLeft) {
      setTimeout(() => {
        setIsTwoMinutesLeft(false);
      }, 3000);
    }
  }, [isTwoMinutesLeft]);

  useEffect(() => {
    if (unspotlight) {
      setTblData(tblDataSnap);
    }
  }, [unspotlight, tblDataSnap]);

  useEffect(() => {
    const producersArray = Object.values(producers);
    const videoProducer: any = producersArray?.find(
      (producer: any) => producer.track.kind === 'video'
    );
    if (videoProducer) {
      const stream = new MediaStream();
      stream.addTrack(videoProducer.track);
      setMyStream({ [profileData?.email]: stream });
    } else {
      setMyStream({ [profileData?.email]: { toURL: () => { } } });
    }
  }, [producers]);

  useEffect(() => {
    if (Object.keys(presentaionData).length > 0) {
      setIsPresentationStarted(true);
    }
  }, [presentaionData]);

  const groupBy = (objectArray: any[], property: string) => {
    return objectArray.reduce(function (acc, obj) {
      var key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  };

  useEffect(() => {
    if (consumers) {
      let _consumers = Object.values(consumers);
      let newConsumerArray = groupBy(_consumers, 'peerId');
      let _newConsumerArray = Object.values(newConsumerArray);
      let origianlStreamArray: any = {};
      _newConsumerArray?.map((c: any) => {
        let stream = new MediaStream();
        let peerId: any;
        let shareTrack = c?.find((s: any) => s?.share);
        if (shareTrack && Object.keys(shareTrack).length > 0) {
          stream.addTrack(shareTrack.track);
          peerId = shareTrack.peerId;
        } else {
          c?.map((c1: any) => {
            stream.addTrack(c1.track);
            peerId = c1.peerId;
          });
        }
        origianlStreamArray = { ...origianlStreamArray, [peerId]: stream };
      });
      setOtherStream(origianlStreamArray);
    }
  }, [consumers]);

  useEffect(() => {
    console.log('otherStream', otherStream);

  }, [otherStream]);

  useEffect(() => {
    console.log('myStream', myStream);

  }, [myStream])

  useEffect(() => {
    const addShareTrack = async () => {
      if (shareConsumer) {
        const stream: any = new MediaStream();
        stream.addTrack(shareConsumer.track);
        setShareStream(stream);
      } else {
        setShareStream({ toURL: () => { } });
      }
    };
    addShareTrack();
  }, [shareConsumer]);

  // useEffect(() => {
  //   if (dropoutState) {
  //     processSocketEvents(dropoutState);
  //   }
  // }, [dropoutState]);

  useEffect(() => {
    setAllStream({ ...otherStream, ...myStream });
  }, [otherStream, myStream]);

  useEffect(() => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
  }, []);

  useEffect(() => {
    const newStream: any[] = Object.keys(allStream);
    setOnlineStream(newStream);
  }, [allStream]);

  useEffect(() => {
    const myEmailInPresentations = manuallySelected?.seats.find(
      (item: any) => item.participant_email === profileData?.email
    );
    setMyEmailInPresentation(myEmailInPresentations || { participant_email: 'no email' });
  }, [manuallySelected, profileData?.email]);

  useEffect(() => {
    calculateHeightWidth();
  }, [tblData?.seats, layoutHeight]);

  // Measure Box dimensions
  useEffect(() => {
    const currentBox = boxRef.current;
    if (!currentBox) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setLayoutHeight(entry.contentRect.height);
      }
    });

    observer.observe(currentBox);
    return () => {
      if (currentBox) observer.unobserve(currentBox);
    };
  }, []);

  useEffect(() => {
    setSelectedView(0);
    if (instructorPresentorData?.isIndividualPresentor) {
      if (instructorPresentorData?.isIndividualPresentorIsMe) {
        setSelectedView(1);
      } else {
        setSelectedView(3);
      }
    }
    if (
      instructorPresentorData?.isIndividualPresentor === false &&
      instructorPresentorData?.isGroupPresentor &&
      !instructorPresentorData?.isGroupPresentorIsMe &&
      !instructorPresentorData?.isPresentingGroupIsOthers &&
      !instructorPresentorData?.isPresentingGroupIsOurs
    ) {
      if (instructorPresentorData && instructorPresentorData?.group?.seats) {
        const targetEmail = profileData?.email;
        let emailFound = false;
        setGroupTable(instructorPresentorData?.group);
        setHardCopyModifiedGroupTableData(instructorPresentorData?.group);
        instructorPresentorData?.group?.seats.forEach((seat: any) => {
          if (seat.participant_email === targetEmail) {
            emailFound = true;
          }
        });
        setIsOurGroupRepresenting(emailFound);
      }
      setSelectedView(2);
    }
    if (
      instructorPresentorData?.isIndividualPresentor === false &&
      instructorPresentorData?.isGroupPresentor &&
      instructorPresentorData?.isGroupPresentorIsMe &&
      !instructorPresentorData?.isPresentingGroupIsOthers &&
      instructorPresentorData?.isPresentingGroupIsOurs
    ) {
      let copyModifiedGroupTableData = JSON.parse(JSON.stringify(groupTable));
      if (copyModifiedGroupTableData) {
        copyModifiedGroupTableData.seats = copyModifiedGroupTableData.seats.filter(
          (seat: any) => seat.participant_email !== instructorPresentorData?.individual?.participant_email
        );
        setHardCopyModifiedGroupTableData(copyModifiedGroupTableData);
      }
      setIsIamRepresentingGroup(true);
      setSelectedView(4);
    }
    if (
      instructorPresentorData?.isIndividualPresentor === false &&
      instructorPresentorData?.isGroupPresentor &&
      !instructorPresentorData?.isGroupPresentorIsMe &&
      instructorPresentorData?.isPresentingGroupIsOthers &&
      !instructorPresentorData?.isPresentingGroupIsOurs
    ) {
      let copyModifiedGroupTableData = JSON.parse(JSON.stringify(groupTable));
      if (copyModifiedGroupTableData) {
        copyModifiedGroupTableData.seats = copyModifiedGroupTableData.seats.filter(
          (seat: any) => seat.participant_email !== instructorPresentorData?.individual?.participant_email
        );
        setHardCopyModifiedGroupTableData(copyModifiedGroupTableData);
      }
      setIsIamRepresentingGroup(false);
      setSelectedView(4);
    }
  }, [instructorPresentorData, alter, profileData?.email]);

  const calculateHeightWidth = () => {
    if (tblData?.seats?.length <= 4) {
      setBoxSize({ height: layoutHeight / 2, width: '50%' });
    } else if (tblData?.seats?.length <= 6) {
      setBoxSize({ height: layoutHeight / 2, width: '33.33%' });
    } else if (tblData?.seats?.length <= 9) {
      setBoxSize({ height: layoutHeight / 3, width: '33.33%' });
    }
  };

  const startTimer = (minutes: any) => {
    setTimeLeft(Number(minutes) * 60);
  };

  const setParticipants = (td: any[]) => {
    let from = 0;
    let to = batchData?.sittingStyle[0]?.nos_of_participant_on_table;
    td.forEach((v: any, i: number) => {
      let p = batchData?.participants?.slice(from, to);
      from = to;
      to = to + batchData?.sittingStyle[0]?.nos_of_participant_on_table;
      td[i].seats = p;
    });
    getTableName([...td]);
  };

  const userToParticipantConverter = (user: {
    id: number;
    participant_id: number;
    name: string;
    participant_name: string;
    email: string;
    participant_email: string;
  }) => {
    if (user.hasOwnProperty('id')) {
      user['participant_id'] = user.id;
    }
    if (user.hasOwnProperty('name')) {
      user['participant_name'] = user.name;
    }
    if (user.hasOwnProperty('email')) {
      user['participant_email'] = user.email;
    }
    console.log('returning user', user);
    return user;
  };

  const selectShareConsumer = (consumers: any) => {
    if (consumers) {
      const consumersArray = Object.keys(consumers);
      for (let i = 0; i < consumersArray.length; i += 1) {
        if (consumers[consumersArray[i]].share) {
          return consumers[consumersArray[i]];
        }
      }
    }
    return null;
  };

  const processSocketEvents = async (dropoutState: any) => {
    if (!dropoutState || !dropoutState.socketEvents) {
      console.error('processSocketEvents: dropoutState is undefined, invalid, or socketEvents is missing');
      return;
    }
    try {
      //   dispatch(storeResponse(dropoutState));
      if (Array.isArray(dropoutState.socketEvents)) {
        for (let i = 0; i < dropoutState.socketEvents.length; i++) {
          const event = dropoutState.socketEvents[i];
          console.log(`--- Starting event #${i} ---`);
          try {
            await handleOnMessage(event.message);
            // Wait for 1 second so the UI can update and user can see the change
            await new Promise(resolve => setTimeout(resolve, 1000));
            console.log(`✓ Finished event #${i}`);
          } catch (e) {
            console.error(`✗ Error in event #${i}:`, e);
          }
        }
      } else {
        console.log("No socketEvents found in the response or socketEvents is not an array.");
      }

    } catch (error) {
      console.error("Error in processSocketEvents:", error);
    }
  };

  const getTableName = async (data: any, showModal: boolean = false) => {
    data?.forEach((tableData: any, i: any) => {
      tableData?.seats?.forEach((v1: any, i1: any) => {
        let item = userToParticipantConverter(v1);
        tableData.seats[i1] = item;
        if (item?.participant_email?.toLowerCase() === profileData?.email?.toLowerCase()) {
          setTblDataSnap(tableData);
          setTblData(tableData);
          getGroupLeader(tableData, showModal);
        }
      });
    });
  };


  const getGroupLeader = (v: any, showModal: boolean = false) => {
    let gl = v?.seats?.find((e: any) => e?.group_leader);
    setGroupleader(gl);
    if (showModal && gl?.participant_name) {
      if (gl?.participant_email === profileData?.email) {
        setCanTransfer(false);
        setModalMode(gdModalType?.YOUSELECTEDGL);
      } else {
        setCanTransfer(false);
        setModalMode(gdModalType?.NOMINATEPRESENTER);
        setModalMode(undefined);
      }
    }
  };

  const updateSessionMetaInfo = () => {
    let objBody = {
      sessionSegmanetId: session_id,
      type: 'VOLUNTEERING',
      traineeList: [profileData?.id],
    };
    // Uncomment and implement API call when ready
    // postDataWithToken(objBody, mobile_siteConfig.MOB_UPDATE_SESSION_META_INFO)
    //   .then((res: any) => {
    //     const { response } = res;
    //     if (response.data && typeof response.data === 'object') {
    //     } else {
    //     }
    //   })
    //   .catch((error: any) => {
    //     console.log(error);
    //   });
  };

  const selectVolunteerFirst = () => {
    if (!userInfoHandler.current) {
      userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    }
    let group_leader = groupleader && Object.keys(groupleader).length > 0;
    let myTable;
    if (profileData?.email && newTblData.length) {
      newTblData.forEach((data: any) => {
        data.seats.forEach((subData: any) => {
          if (subData.participant_email === profileData?.email) {
            myTable = data;
          }
        });
      });
    }
    let user_data = {
      userEmail: profileData?.email,
      userName: profileData?.name,
      seatingPlan: myTable,
      newTblData,
      groupLeader: group_leader,
      timeStamp: Date.now(),
    };
    userInfoHandler.current.sendMessage(
      JSON.stringify({
        sub_type: 'system_request_accepted',
        type: 'group_discussion',
        user_data: user_data,
        room_id: sessionId,
      })
    );
    setModalMode(gdModalType.NOMINATEPRESENTER);
    setModalMode(undefined);
  };

  const nominateParticipant = () => {
    if (selectedIndex === -1) {
      console.log('*** pls select participant ***');
    } else {
      let group_leader = groupleader && Object.keys(groupleader).length > 0;
      if (!userInfoHandler.current) {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      }
      let payload = {
        sub_type: 'system_request_accepted',
        type: 'group_discussion',
        room_id: sessionId,
        nominatedParticipantData: {
          isLeader: group_leader,
          leaderData: {
            isLeader: group_leader,
            leaderEmail: groupleader?.participant_email,
          },
          selectedNominee: tblData?.seats[selectedIndex],
          selectedBy: profileData?.email,
          group: tblData,
        },
      };
      userInfoHandler.current.sendMessage(JSON.stringify(payload));
      setModalMode(undefined);
    }
  };

  const nominateGroupleader = (nominee: any) => {
    if (nominee) {
      if (!userInfoHandler.current) {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      }
      let payload = {
        sub_type: 'select_group_leader_each_GM',
        type: 'group_discussion',
        room_id: sessionId,
        activityData: [
          {
            selectedParticipant: nominee,
            whoSelected: profileData?.email,
          },
        ],
        timestamp: new Date(),
      };
      userInfoHandler.current.sendMessage(JSON.stringify(payload));
      setModalMode(undefined);
    }
  };

  const allNominateGroupleader = (nominee: any) => {
    if (nominee) {
      if (!userInfoHandler.current) {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      }
      let payload = {
        sub_type: 'each_leader_select_GM',
        type: 'group_discussion',
        room_id: sessionId,
        activityData: {
          selectedLeader: nominee,
          currentGroupName: tblData?.table_name,
          selected_by: profileData?.email,
        },
        timestamp: new Date(),
      };
      userInfoHandler.current.sendMessage(JSON.stringify(payload));
      setModalMode(undefined);
    }
  };

  const OkayGroupleader = () => {
    if (canTransfer) {
      if (!userInfoHandler.current) {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      }
      let payload = {
        sub_type: 'select_group_leader_each_GM',
        type: 'group_discussion',
        room_id: sessionId,
        activityData: {
          selectedMail: profileData?.email,
          selectedName: profileData?.name,
          table_name: tblData?.table_name,
        },
        timestamp: new Date(),
      };
      userInfoHandler.current.sendMessage(JSON.stringify(payload));
      setCanTransfer(false);
    }
    setModalMode(undefined);
  };

  useEffect(() => {
    if (modalMode === 'WHEN_GROUP_IS_PRESENTING') {
      roomClient.consumerResumeAllAudio();
    } else if (modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS' && manuallySelected) {
      console.log('manuallySelected bye', manuallySelected);

      roomClient.consumerMuteParticipantByGroup(manuallySelected, 'trainer@vtt');
    }
  }, [modalMode])

  useEffect(() => {
    const debouncedUpdate = debounce(() => {
      console.log('manuallySelected bye', manuallySelected);
      console.log('myEmailInPresentation bye', myEmailInPresentation);

      if (modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS' && manuallySelected) {
        if (myEmailInPresentation?.participant_email === profileData?.email) {
          roomClient?.consumerMuteParticipantByGroup(manuallySelected, 'trainer@vtt');
        }
      }
    }, 100);
    debouncedUpdate();
    return () => debouncedUpdate.cancel();
  }, [modalMode, manuallySelected]);

  const startManuallyPresentation = () => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    let obj1 = {};
    const isEmailMatched = manuallySelected?.seats.filter((item: any) => {
      if (item.participant_email === profileData?.email) {
        return item;
      }
    });
    if (isEmailMatched[0]?.participant_email) {
      obj1 = {
        seat_number: isEmailMatched[0].seat_number,
        participant_id: isEmailMatched[0].participant_id,
        participant_name: isEmailMatched[0].participant_name,
        participant_email: isEmailMatched[0].participant_email,
        profilePhoto: 'null',
      };
    }
    userInfoHandler.current.sendMessage(
      JSON.stringify({
        type: 'group_discussion',
        sub_type: 'launch_presentation_screen',
        room_id: session_id,
        activityData: {
          TableName: manuallySelected?.table_name,
          action: 'start_own_presentation',
          role: 'group_discussion',
          trainee: isEmailMatched[0],
        },
      })
    );
    setHideOurDraggableView(true);
    setIsIamRepresentingGroup(true);
  };

  const startGroupPresentation = () => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    let obj1 = {
      seat_number: gdSelectedTraineeForPresentation?.seat_number,
      participant_id: gdSelectedTraineeForPresentation?.participant_id,
      participant_name: gdSelectedTraineeForPresentation?.participant_name,
      participant_email: gdSelectedTraineeForPresentation?.participant_email,
      profilePhoto: 'null',
    };
    userInfoHandler.current.sendMessage(
      JSON.stringify({
        type: 'group_discussion',
        sub_type: 'launch_presentation_screen',
        room_id: session_id,
        activityData: {
          TableName: presentationOrder?.groupName,
          action: 'start_own_presentation',
          role: 'group_discussion',
          trainee: obj1,
        },
      })
    );
    setHideOurDraggableView(true);
    setIsIamRepresentingGroup(true);
  };

  const EndPresentation = () => {
    setHideOurDraggableView(false);
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    let obj1 = {
      seat_number: gdSelectedTraineeForPresentation?.seat_number,
      participant_id: gdSelectedTraineeForPresentation?.participant_id,
      participant_name: gdSelectedTraineeForPresentation?.participant_name,
      participant_email: gdSelectedTraineeForPresentation?.participant_email,
      profilePhoto: 'null',
    };
    userInfoHandler.current.sendMessage(
      JSON.stringify({
        type: 'group_discussion',
        sub_type: 'launch_presentation_screen',
        room_id: session_id,
        activityData: {
          TableName: 'Group 1',
          action: 'end_own_presentation',
          role: 'group_discussion',
          trainee: obj1,
        },
      })
    );
  };

  const startPresentation = () => {
    let payload = {
      sub_type: gdSubtype?.LAUNCH_PRESENTATION_SCREEN,
      type: socketMessageType?.GROUP_DISCUSSION,
      room_id: session_id,
      activityData: {
        activePresentation: presentaionType,
        fileUrl: fileToPresent,
        presentNominee: profileData?.email,
        myGroups: tblDataRef?.current?.seats,
      },
    };
    if (presentaionType === 'share_screen' && roomClient) {
      roomClient.enableShare();
    }
    setShowStartPresentation(false);
    if (!userInfoHandler.current) {
      userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    }
    userInfoHandler.current.sendMessage(JSON.stringify(payload));
  };

  const handleEndPresentation = () => {
    if (!userInfoHandler.current) {
      userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    }
    let payload = {
      sub_type: gdSubtype?.END_PRESENTATION,
      type: socketMessageType?.GROUP_DISCUSSION,
      room_id: session_id,
      timestamp: new Date(),
    };
    userInfoHandler.current.sendMessage(JSON.stringify(payload));
    if (roomClient) {
      roomClient.disableShare();
    }
    setModalMode(undefined);
  };

  const muteTrainer = (caller: string) => {
    return false;
  };

  const onPreparationComplete = () => {
    setModalMode(undefined);
    setShowStartPresentation(true);
  };

  const getGroupName = (groupName: string) => {
    let grpName = '';
    if (groupName && typeof groupName === 'string') {
      const seq = groupName?.split(' ');
      if (seq.length > 1) {
        grpName = 'Group ' + seq[1];
      }
    }
    return grpName;
  };

  const isBlankObject = (value: Object) => {
    if (typeof value === 'object' && value !== null) {
      return Object.keys(value).length === 0;
    }
    return false;
  };

  const handleOnMessage = async (_data: any) => {
    const data = JSON.parse(_data);
    console.log('*** socket msg ***', JSON.stringify(data));

    if (data.type === 'live_session' && data.sub_type === 'time_extend' && data.step === 'Presentation') {
      const messageId = data.messageId || JSON.stringify(data);

      if (presentationExtendTimeIdRef.current === messageId) {
        console.log('Duplicate extend time message, ignoring');
        return;
      }

      presentationExtendTimeIdRef.current = messageId;
      setExtendedTime({ visible: true, time: data.extend_time });
      const extendedMinutes = Number(data.extend_time) || 0;
      setPMinutes(prev => {
        const newTime = prev + extendedMinutes;
        console.log('PRESENTATION TIME EXTENDED:', extendedMinutes, 'minutes | Total:', newTime, 'minutes');
        return newTime;
      });
      setTimeout(() => {
        setExtendedTime({ visible: false, time: 0 });
      }, 5000);
    }
    if (data.type === 'live_session' && data.sub_type === 'time_extend' && data.step === 'group_discussion') {
      const messageId = data.messageId || JSON.stringify(data);

      if (lastExtendTimeIdRef.current === messageId) {
        console.log('Duplicate extend time message, ignoring');
        return;
      }

      lastExtendTimeIdRef.current = messageId;
      setGDAlotTime(prev => {
        const prevNum = Number(prev) || 0;
        const extendNum = Number(data?.extend_time) || 0;
        const total = prevNum + extendNum;
        console.log('GD ALOT TIME EXTEND', data.extend_time, 'Total:', total);
        return Number.isFinite(total) ? total : 0;
      });
    }

    if (data?.type === 'group_discussion' && data?.sub_type === 'select_group_leader_each_GM') {
      if (tblData?.table_name === data.activityData.table_name) {
        setCanTransfer(false);
        setModalMode(undefined);
      }
    }

    if (data?.type === 'group_discussion') {
      if (data?.sub_type === 'launch_presentation_screen') {
        setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
      }
      if (data.sub_type === 'selected_group_order') {
        if (data.groupGoingToPresent) {
          setManuallySelected(data?.groupGoingToPresent);
          setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
        }
      }
      if (data?.sub_type === 'ask_group_to_present_presenation') {
        if (data?.groupGoingToPresent) {
          if (data?.step) {
            setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
          } else {
            const manualPresent = data?.groupGoingToPresent.seats.find(
              (item: any) => item.participant_email === profileData?.email
            );
            if (profileData?.email === manualPresent?.participant_email) {
              setModalMode('MANUALLY_PRESENTER_SCREEN');
            }
          }
          const duration = gdActivityRef.current?.duration_presntation ?? 3;
          setPMinutes(duration);
          setPSeconds(0);
          setManuallySelected(data.groupGoingToPresent);
        }
      }
      if (data?.sub_type === 'ask_group_to_present_presenation' && data?.step === 'end_presentation') {
        setModalMode(false);
      }
      if (data?.sub_type === 'system_request_accepted') {
        if (data?.user_data.userEmail === profileData.email) {
          setModalMode(false);
        }
        const newDatax = data?.user_data?.seatingPlan;
        let newData = Array.isArray(newDatax) ? newDatax : [newDatax];

        const checkEmails1 = (email1: string, email2: string, newData: any[]) => {
          for (let i = 0; i < newData.length; i++) {
            const group = newData[i];
            const seats = group?.seats;
            let email1Found = false;
            let email2Found = false;
            for (let j = 0; j < seats.length; j++) {
              const participant = seats[j];
              if (participant.participant_email === email1) {
                email1Found = true;
              } else if (participant.participant_email === email2) {
                email2Found = true;
              }
            }
            if (email1Found && email2Found) {
              return true;
            }
          }
          return false;
        };

        if (profileData?.email && data?.user_data?.userEmail && tblDataSnap) {
          const checkIfOurGroupAcceptedTheEmail = checkEmails1(
            profileData?.email,
            data?.user_data?.userEmail,
            newData
          );
          if (checkIfOurGroupAcceptedTheEmail) {
            setModalMode(gdModalType.NOMINATEPRESENTER);
            setModalMode(undefined);
          } else {
            return
          }
        }
      }
      if (data?.sub_type === 'trainer_joined_group') {
        const isMyEmailParticipant = data.participants.some(
          (participant: any) => participant.participant_email === profileData.email
        );
        const trainerDetail = data.participants.find(
          (participant: any) => participant.participant_email === 'trainer@vtt'
        );
        if (trainerDetail) {
          trainerDetail.table_name = data.table_name;
        }
        if (isMyEmailParticipant) {
          setTblData((prevData: any) => {
            return {
              ...prevData,
              seats: [...prevData.seats, trainerDetail],
            }
          });
        }
        setIsTrainerPresent(trainerDetail);
        dispatch(updateLiveStreamSettings({
          trainerJoinedtable: {
            isTrainerPresent: true,
            groupName: data.table_name,
            TrainerJoinTableData: data.participants
          }
        }))
      } else if (data?.sub_type === 'trainer_leave_group') {
        const myGroup = data.participants.some(
          (participant: any) => participant.participant_email === profileData.email
        );
        if (myGroup) {
          const newSeats = data.participants.filter(
            (participant: any) => participant.participant_email !== 'trainer@vtt'
          );
          setTblData((prevData: any) => {
            return { ...prevData, seats: newSeats };
          });
        }
        setIsTrainerPresent({});
        dispatch(updateLiveStreamSettings({
          trainerJoinedtable: {
            isTrainerPresent: false,
            groupName: '',
            TrainerJoinTableData: []
          }
        }))
      }
      if (data.sub_type === 'progress_group_discussion') {
        setModalMode(gdModalType.SETUP);
      }
      if (data.sub_type == "launch_group_discussion") {
        var allotedTime = data?.activityData?.alot_time;
        startTimer(Number(allotedTime))
      }
      if (data.type === socketMessageType.SPLIT_ROOM) {
        getTableName(data?.newGroups?.table);
        setNewTblData(data?.newGroups?.table);
      }
      if (data.sub_type === 'launch_group_discussion') {
        setNewTblData(data?.activityData?.case);
        setModalMode(gdModalType?.NOMINATEPRESENTER);
        setGDActivityData(data?.activityData);
        gdActivityRef.current = data?.activityData;
        setModalMode(undefined);
      }
      if (data.sub_type === 'launch_spotlight_screen') {
        if (!isBlankObject(data.activityData)) {
          setTblData(data.activityData);
        }
        setUnspotlight(false);
      } else if (data.sub_type === 'launch_un_spotlight_screen') {
        setUnspotlight(true);
      } else if (data.sub_type === 'launch_group_discussion') {
        getTableName(data?.activityData?.case);
        setGDActivityData(data?.activityData);
      }

      if (data?.sub_type == gdSubtype.GROUP_DISCUSSION_ENDED) {
        setModalMode(gdModalType.DISCUSSION_ENDED)
        return;
      }

      if (data.sub_type === 'complete_group_discussion_set_up') {
        getTableName(data?.activityData?.case || JSON.parse(batchData?.sittingStyle[0]?.table));
        setGDAlotTime(Number(data?.activityData?.alot_time || 0));
        console.log('GD ALOT TIME SET', data?.activityData?.alot_time)

        setModalMode(gdModalType.COMMENCE);
        updateSessionMetaInfo();
        setTimeout(() => {
          setModalMode(undefined);
        }, 2000);
      }
      if (data.sub_type === 'i_will_verbally_instruct_each_group') {
        setGLMmode('i_will_verbally_instruct_each_group');
        if (groupleaderRef?.current) {
          if (groupleaderRef?.current?.participant_email === profileData?.email) {
            setCanTransfer(true);
            setModalMode(gdModalType?.YOUSELECTEDGL);
          }
        } else {
          setGroupOrder(tblDataRef?.current?.seats[0]);
          if (tblDataRef?.current?.seats[0]?.participant_email === profileData?.email) {
            setCanTransfer(true);
            setModalMode(gdModalType?.YOUSELECTEDGL);
          }
        }
        return
      }
      if (data.sub_type === 'leader_system_select') {
        setGLMmode('leader_system_select');
        const newData = JSON.parse(data?.activityData?.activity_data).case;
        setGroupLeaderDetails(newData);
        getTableName(newData);
        const isParticipantGroupLeader = () =>
          newData.some((group: any) =>
            group.seats.some((seat: any) => seat.participant_email === profileData?.email && seat.group_leader)
          );
        if (isParticipantGroupLeader()) {
          setModalMode(gdModalType?.YOUSELECTEDGL);
        } else {
          setModalMode(gdModalType?.NOMINATEPRESENTER);
          setModalMode(undefined);
        }
        if (groupleaderRef?.current) {
          if (groupleaderRef?.current?.participant_email == profileData?.email) {
            setCanTransfer(true)
            setModalMode(gdModalType?.YOUSELECTEDGL)
          }
        }
        else {
          getTableName(data?.activityData?.case, true);
          const seats = tblDataRef?.current?.seats;
          if (Array.isArray(seats) && seats.length > 0) {
            setGroupOrder(seats[0]);
            if (seats[0]?.participant_email === profileData?.email) {
              setCanTransfer(true);
              setModalMode(gdModalType?.YOUSELECTEDGL);
            }
          }

        }
        return
      }
      if (data.sub_type === 'leader_each_select') {
        setGLMmode('leader_each_select');
        setGroupLeaderDetails(data?.activityData?.case || JSON.parse(batchData?.sittingStyle[0]?.table));
        setIsGlTransfer(false);
        setModalMode(gdModalType?.NOMINATEGL);
      }
      if (data?.sub_type == 'leader_nominated') {
        setGLMmode('leader_each_select')
        setGroupLeaderDetails((v) => {
          return data?.activityData?.case || JSON.parse(batchData?.sittingStyle[0]?.table)
        })
        setModalMode(gdModalType?.NOMINATEPRESENTER)
        setModalMode(undefined)
        setIsGlTransfer(false)
        // setModalMode(gdModalType?.NOMINATEGL)
        return
      }
      if (data.sub_type === 'leader_trainer_select') {
        setGLMmode('leader_trainer_select');
        setGroupLeaderDetails(data?.activityData?.case || JSON.parse(batchData?.sittingStyle[0]?.table));
        getTableName(data?.activityData?.case || JSON.parse(batchData?.sittingStyle[0]?.table), true);
      }
      if (data?.type == "role_play" && data?.typeOfSelection == 'system_select') {
        setModalMode(gdModalType.YOUSELECTEDGL)
        if (groupleaderRef?.current) {
          if (groupleaderRef?.current?.participant_email == profileData?.email) {
            setCanTransfer(true)
            setModalMode(gdModalType?.YOUSELECTEDGL)
          }
        }
        else {
          setGroupOrder(tblDataRef?.current?.seats[0])
          if (tblDataRef?.current?.seats[0]?.participant_email == profileData?.email) {
            setCanTransfer(true)
            setModalMode(gdModalType?.YOUSELECTEDGL)
          }
        }
        return
      }
      if (data.sub_type === gdSubtype.ALLOW_GROUPS_TO_VOLUNTEER || data.sub_type === gdSubtype.VOLUNTEER_FOR_CASE_STUDY) {
        setBriefMode('volunteer_mode');
        if (groupleaderRef.current) {
          if (groupleaderRef.current?.participant_email == profileData?.email) {
            // show volunteer modal to team leader
            setModalMode(gdModalType?.READY_TO_PRESENT_GROUP_LEADER);
            setModalMode(gdModalType?.READY_TO_PRESENT_ALL);
          }
          else {
            // show wait modal to other participent
            setModalMode(gdModalType?.WAIT);
            setModalMode(gdModalType?.READY_TO_PRESENT_ALL);

          }
        } else {
          // show volunteer modal to all participent
          setModalMode(gdModalType?.READY_TO_PRESENT_ALL);
        }
        return;
      }
      if (data?.sub_type == gdSubtype.VOLUNTEER_FOR_CASE_STUDY) {
        console.log("*** VOLUNTEER_FOR_CASE_STUDY ***")
        if (groupleaderRef.current) {
          if (groupleaderRef.current?.participant_email == profileData?.email) {
            console.log("READY_TO_PRESENT_GROUP_LEADER")
            setModalMode(gdModalType?.READY_TO_PRESENT_GROUP_LEADER);
          }
          else {
            console.log("WAIT")
            // setModalMode(gdModalType?.WAIT);
            setModalMode(undefined);
          }
        } else {
          console.log("READY_TO_PRESENT_ALL")
          setModalMode(gdModalType?.READY_TO_PRESENT_ALL);
        }
        return
      }
      if (data.sub_type === gdSubtype.SELECTED_GROUP_ORDER) {
        if (data?.groupOrder?.length > 0) {
          const findParticipantByEmail = (email: string) => {
            for (let i = 0; i < data.groupOrder.length; i++) {
              const group = data.groupOrder[i];
              for (let j = 0; j < group.seats.length; j++) {
                if (group.seats[j].participant_email === email) {
                  dispatch(
                    gdGroupDiscussionParticipants({
                      gdSelectedTraineeForPresentation: group.seats[j]
                    })
                  )
                  return { groupName: group.group_name, index: i };
                }
              }
            }
            return null;
          };
          const participantEmail = profileData?.email;
          const result = findParticipantByEmail(participantEmail);
          if (result) {
            setPresentationOrder({
              ...presentationOrder,
              groupName: result.groupName,
              rankOrder: String(result.index),
            });
            setModalMode('SHOW_RANK_ORDER_FOR_PRESENTATION');
          }
        }
      }
      if (data?.sub_type == gdSubtype?.LEADER_TRAINER_SELECT) {
        setGroupOrder(data?.activityData?.case)
        return
      }
      if (data.sub_type === gdSubtype.ASK_GROUP_TO_PRESENT_PRESENATION) {
        if (data?.activityData?.selected_nominee?.selectedNom_email === profileData?.email) {
          setModalMode(gdModalType?.STARTPRESENTATION);
        }
      }
      if (data.sub_type === gdSubtype.ASK_GROUP_TO_PRESENT) {
        setBriefMode('verbally_mode');
        if (groupleaderRef.current) {
          if (groupleaderRef.current?.participant_email === profileData?.email) {
            setModalMode(gdModalType?.READY_TO_PRESENT_GROUP_LEADER);
          } else {
            setModalMode(gdModalType?.WAIT);
          }
        } else {
          setModalMode(gdModalType?.READY_TO_PRESENT_ALL);
        }
      }
      if (data?.sub_type == gdSubtype.INITIATE_SELECTED_GROUP_ORDER) {
        return
      }
      if (data.sub_type === gdSubtype.DRAG_SELECTED_GROUP_ORDER) {
        setGroupOrder([...data?.activityData?.groupOrderListByTrainer]);
        setModalMode(gdModalType.DISCUSSION_ENDED);
        return;
      }
      if (data.sub_type === gdSubtype.OPEN_CLASS_INTERACTION) {
        setModalMode('OPEN_CLASS_INTERACTION_IN_PROGRESS');
        if (data?.timeForOCI) setMinutes(data?.timeForOCI);
        return;
      }
      if (data.sub_type === 'end_open_class_interaction') {
        setModalMode(false);
      }
      if (data.sub_type === 'share_white_board') {
        setModalMode(undefined);
      }
      if (data.sub_type === gdSubtype.LAUNCH_PRESENTATION_SCREEN) {
        if (data?.activityData?.action === 'start_own_presentation' && data?.activityData?.trainee?.participant_email !== undefined) {
          setRemovedEmail(data?.activityData?.trainee?.participant_email);
          setModalMode('WHEN_GROUP_IS_PRESENTING');
          setPresentationOrder({
            ...presentationOrder,
            traineeDetails: data?.activityData?.trainee,
          });
        }
        if (data?.activityData?.action === 'end_own_presentation' && data?.activityData?.trainee?.participant_email !== undefined) {
          console.log('end own presentation')
          setRemovedEmail(data?.activityData?.trainee?.participant_email);

          // check if the  data?.activityData?.trainee?.participant_email is in our group or not???
          console.log('tbldata::::::::::::::tblDAta:::::::', tblData);


          if (typeof tblData === 'object' && Array.isArray(tblData)) {
            var newData = tblData;
            console.log('newData is neither an object nor an array1', newData);
          } else if (typeof tblData === 'object') {
            var newData = [tblData];
            console.log('newData is neither an object nor an array2', newData);
          } else {
            console.log('newData is neither an object nor an array');
          }
          const checkEmails = (email1, email2, newData) => {
            console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::1 bye', newData);

            for (let i = 0; i < newData.length; i++) {
              const group = newData[i];
              console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::3 bye', group);

              const seats = group?.seats || [];
              console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::4 bye', seats);

              let email1Found = false;
              let email2Found = false;
              if (seats.length > 0) {
                for (let j = 0; j < seats.length; j++) {
                  const participant = seats[j];
                  //
                  if (participant.participant_email === email1) {
                    email1Found = true;
                  }
                  else if (participant.participant_email === email2) {
                    email2Found = true;
                  }
                }
              }
              if (email1Found === true) {
                if (email2Found == true) {
                  return true;
                }
              }

              if (email2Found === true) {
                if (email1Found == true) {
                  return true;
                }
              }
            }
            return false;
          };
          if (profileData?.email !== undefined && data?.activityData?.trainee?.participant_email !== undefined && tblDataSnap !== undefined) {

            var checkIfOurGroupAcceptedTheEmail = checkEmails(profileData?.email, data?.activityData?.trainee?.participant_email, newData)
            // console.log('checkIfOurGroupAcceptedTheEmail', checkIfOurGroupAcceptedTheEmail)
            if (checkIfOurGroupAcceptedTheEmail) {

              setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
              setPresentationOrder({
                ...presentationOrder,
                traineeDetails: data?.activityData?.trainee,
                isOurGroupIsGoingToRepresent: true
              })
            } else {
              setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
              setPresentationOrder({
                ...presentationOrder,
                traineeDetails: data?.activityData?.trainee,
                isOurGroupIsGoingToRepresent: false
              })
              return
            }
          }
        }
      }
      if (data?.sub_type === gdSubtype.CASE_STUDY_SETUP && data?.activityData?.isSetupProcess) {
        setModalMode(gdModalType.ENDWAIT);
      }
      if (data?.sub_type === gdSubtype.CONFIRM_EACH_GROUP_PICKS_GL) {
        const glSelectionData: any[] = data?.activityData?.selected_leader_each;
        const amIGL = glSelectionData?.find(
          (item) => item.email === profileData?.email || item.participant_email === profileData?.email
        );
        if (amIGL) {
          setGroupleader(amIGL);
          if (
            groupleaderRef?.current?.participant_email === profileData?.email ||
            groupleaderRef?.current?.email === profileData?.email
          ) {
            setModalMode(gdModalType?.YOUSELECTEDGL);
            setCanTransfer(false);
          } else {
            setModalMode(gdModalType?.YOUSELECTEDGL);
            setCanTransfer(false);
          }
        } else {
          let myGroupGl = glSelectionData.find(
            (selected) => getGroupName(selected.table_name) === getGroupName(tblDataRef.current?.table_name)
          );
          if (myGroupGl) {
            setGroupleader(myGroupGl);
            setMessageCxt({
              visible: true,
              message: `You have nominated and selected ${myGroupGl?.name || myGroupGl?.participant_name} as your Group Leader!`,
            });
          }
        }
      }
      if (data?.sub_type === gdSubtype.TIME_ABOUT_TO_OVER) {
        if (data?.activityData?.comingGroup?.group_name === tblDataRef?.current?.table_name) {
          if (data?.activityData?.comingGroup?.selected_nominee?.selectedNom_email === profileData?.email) {
            setModalMode(gdModalType?.YOUNEXT);
          }
        }
        if (data?.activityData?.currentGroup?.group_name === tblDataRef?.current?.table_name) {
          if (data?.activityData?.currentGroup?.selected_nominee?.selectedNom_email === profileData?.email) {
            setModalMode(gdModalType.WRAP_IN_TWO);
          }
        }
      }
      if (data?.sub_type === gdSubtype.HANDLE_TRAINER_RESPONSE_ONEXTEND) {
        if (data?.activityData?.comingGroup?.group_name === tblDataRef?.current?.table_name) {
          if (data?.activityData?.comingGroup?.selected_nominee?.selectedNom_email === profileData?.email) {
            setModalMode(gdModalType?.TRAINER_HAS_EXTENDED_TIME);
          } else {
            setModalMode(undefined);
          }
        }
      }
      if (data?.sub_type === gdSubtype.END_PRESENTATION) {
        setIsPresentationStarted(false);
        if (roomClient) {
          roomClient.disableShare();
        }
        setModalMode(undefined);
      }
    };
    if (data.type === 'launch_case_study' && data.sub_type === 'reset_group_data') {
      if (data?.activityData?.table_data && Array.isArray(data?.activityData?.table_data)) {
        const currentGrp = data?.activityData?.table_data?.find((item: any) => item?.table_name === 'Group 1');
        const gldata = currentGrp?.seats?.find((item: any) => item?.group_leader === true);
        setGroupleader(gldata);
      }
    }
  }

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS' &&
      (pminutes > 0 || pseconds > 0)) {

      interval = setInterval(() => {
        setPSeconds(prevSeconds => {
          if (prevSeconds === 0) {
            if (pminutes === 0) {
              clearInterval(interval);
              // Timer completed - handle presentation end
              // handlePresentationTimeUp();
              return 0;
            } else {
              setPMinutes(prevMinutes => prevMinutes - 1);
              return 59;
            }
          } else {
            return prevSeconds - 1;
          }
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [modalMode, pminutes, pseconds]);

  useEffect(() => {
    if (modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS') {
      // Start with default 3 minutes when presentation becomes visible
      const duration = gdActivityRef.current?.duration_presntation ?? 3;
      setPMinutes(duration);
      setPSeconds(0);
    }
  }, [modalMode]);

  const handlePresentationTimeUp = () => {
    console.log('Presentation time is up!');
    // Add your logic here for when time runs out
    // For example: automatically end presentation, show warning, etc.

    if (profileData?.email === myEmailInPresentation?.participant_email) {
      // If current user is presenting, end their presentation
      EndPresentation();
    }

    // Show time up message
    setMessageCxt({
      visible: true,
      message: 'Presentation time has ended!'
    });
  };

  useEffect(() => {
    console.log('modalMode', modalMode);
  }, [modalMode]);

  const renderModalContent = () => {
    switch (modalMode) {
      case gdModalType.SETUP:
        return (
          <div>
            <div className="flex items-center justify-center my-6">
              <div className="bg-[rgba(33,32,37,0.8)] w-fit rounded-lg py-2 px-4 gap-4 border-[1px] border-[#545455] flex flex-row items-center justify-center">
                <Text className="text-[#E9BE50] text-[10px] font-bold">Group Discussion setup in progress ...</Text>
                <div className="h-[8px] w-[8px] rounded-full bg-[#43A047] border-[1px] border-[#E9BE50]"></div>
              </div>
            </div>
            <OpenClassInteraction roomClient={roomClient} tableDetails={batchData?.participants} />
          </div>
          // <div className="flex flex-1 flex-col justify-center items-center h-full w-full">
          //   <div className="relative w-full max-w-[536px] mobile:max-w-[90%] bg-gray-800 rounded-2xl flex items-center px-4 py-6 shadow-lg">
          //     <img
          //       src={groupDiscussion}
          //       alt="Group Discussion"
          //       className="object-contain w-12 h-12 mr-4"
          //       width={100}
          //       height={100}
          //     />

          //     <div className="flex flex-col">
          //       <span className="text-sm tablet:text-base laptop:text-lg desktop:text-xl font-medium text-gray-300">
          //         Group Discussion setup in progress ...
          //       </span>
          //       <span className="text-base tablet:text-lg laptop:text-xl desktop:text-2xl text-[#E9BE50] italic font-semibold mt-1">
          //         Standby ... you will shortly commence the discussion in groups
          //       </span>
          //     </div>
          //   </div>
          // </div>

        );
      case gdModalType.READY_TO_PRESENT_ALL:
        return (
          <GdReadyToPresent showButton={true} onPress={selectVolunteerFirst}></GdReadyToPresent>
        );
      case gdModalType.READY_TO_PRESENT_GROUP_LEADER:
        return (
          <GdReadyToPresent showButton={groupleader?.participant_email === profileData?.email} onPress={selectVolunteerFirst}></GdReadyToPresent>
        );
      case gdModalType.STARTPRESENTATION:
        return (
          <GdStartPresenter onPress={() => setModalMode(gdModalType?.COMPLETEPREPARATION)} nominateType={groupleaderRef.current ? nominationType.GROUP_LEADER : nominationType.GROUP_MEMBERS}></GdStartPresenter>
        );
      case gdModalType.COMPLETEPREPARATION:
        return (
          <GdCompletePreparation onDone={onPreparationComplete}
            setFileUrl={setFileToPresent}
            activePresentation={(pt: string) => setPresentaionType(pt)}></GdCompletePreparation>
        );
      case gdModalType.WAIT:
        return (
          <GdWait />
        );
      case gdModalType.COMMENCE:
        return (
          <GdCommence />
        );
      case gdModalType.DISCUSSION_ENDED:
        return (
          <GdEndWait />
        );
      case gdModalType.NOMINATEPRESENTER:
        return <>

        </>;
      case gdModalType.YOUSELECTEDGL:
        return (
          <GDGroupleader
            canTransfer={canTransfer}
            onTransfer={() => {
              setIsGlTransfer(true)
              setModalMode(gdModalType?.NOMINATEGL)
            }}
            onOkay={OkayGroupleader}
            glmMode={GLMmode}
          />
        );
      case gdModalType.NOMINATEGL:
        return (
          <GDGroupleader
            canTransfer={canTransfer}
            onTransfer={() => {
              setIsGlTransfer(true)
              setModalMode(gdModalType?.NOMINATEGL)
            }}
            onOkay={OkayGroupleader}
            glmMode={GLMmode}
          />
        );
      case gdModalType.RANDOMLYSELECTED:
        return (
          <GdRandomlySelected
            name={randomlySelected}
            onClose={() => setModalMode(undefined)}
            glmMode={GLMmode}
          />
        );
      case 'MANUALLY_PRESENTER_SCREEN':
        return (
          <AsktoPresent
            showButton={true}
            onPress={() => setModalMode("SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS1")}
            groupName={presentationOrder?.groupName}
            presentationRank={presentationOrder?.rankOrder}
          />
        );
      case 'SHOW_RANK_ORDER_FOR_PRESENTATION':
        return (
          <GdPresentationRankOrder
            showButton={true}
            onPress={() => {
              // case 2:-- all participants will press ok
              // >>check if i am in the presenting group or not
              // if yes:--start presentation option and send socket message:-->>
              // if no:-- then after pressing ok show the other view
              if (Number(presentationOrder?.rankOrder) == 0) {
                console.log('presentationOrder?.rankOrder::::::::: we will presnet the screen::')
                setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS'); //setting it so that user can see the blank area on the screen
                setPresentationOrder({
                  ...presentationOrder,
                  isOurGroupIsGoingToRepresent: true,
                })
                return
              } else {
                setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS'); //setting it so that user can see the blank area on the screen
                setPresentationOrder({
                  ...presentationOrder,
                  isOurGroupIsGoingToRepresent: false,
                })
                return
              }
            }}
            groupName={presentationOrder?.groupName}
            presentationRank={presentationOrder?.rankOrder}
          />
        );
      case 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS':
        return (
          <div className="flex flex-col items-center h-full  relative">
            <div className=" items-center flex justify-center mx-2 w-full my-5">
              <div className="bg-gray-900 max-w-xs w-full px-4 w-fit py-2 rounded-xl" style={{ borderRadius: "8px", backgroundColor: "#24272C", boxShadow: "-2px -2px 4px 0 rgba(255, 255, 255, 0.25), 2px 2px 4px 0 rgba(0, 0, 0, 0.25)", }}>
                <p className="text-white flex justify-center text-sm">
                  {manuallySelected?.group_name || manuallySelected?.table_name}
                </p>
              </div>
            </div>
            {/* <div className="absolute top-1 w-full flex justify-center">
              <Flex
                align="center"
                justify="center"
                className="bg-[rgba(33,32,37,0.8)] w-[55%] rounded-lg py-2 px-4 border-[2px] border-[rgba(84,84,85,1)]"
              >
                <Text className="text-[#E9BE50] text-sm font-bold">Group Discussion debrief in progress</Text>
                <Box className="w-3" />
                <Box className="h-3 w-3 rounded-full bg-[rgba(67,160,71,1)] border-[2px] border-[rgba(233,190,80,1)]" />
              </Flex>
            </div> */}
            {/* //timer */}
            <div className="ml-auto me-4 mobile:ml-0 mobile:me-0 mobile:w-full mobile:flex mobile:justify-end">
              <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
                <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
                <div className="flex flex-row items-center justify-center gap-1">
                  <span className="text-[#E9BE50] text-[10px]">{pminutes}m</span>
                  <span className="text-[#E9BE50] text-[10px]">{pseconds}s</span>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col h-full justify-start my-5">
              <div className="grid grid-cols-3 tablet:grid-cols-3 laptop:grid-cols-4 mobile:grid-cols-2 text-white mobile:gap-y-4 mobile:gap-0 gap-2 m-2">
                {manuallySelected?.seats?.map((item: any, index: number) => (
                  <Box key={item.id}>
                    <TableElementNew
                      hideKebab={true}
                      elementStyle={{
                        borderWidth: 1,
                        borderRadius: 1,
                        borderColor: '#D3D3D3',
                        marginVertical: 0.4,
                      }}
                      onPress={() => { }}
                      userData={item}
                      isExpandedView={true}
                      groupLeaderEmail={undefined}
                    />
                  </Box>
                ))}
              </div>
            </div>
            {/* {profileData?.email === myEmailInPresentation?.participant_email && (
              <Button
                onClick={() => {
                  console.log('start presentation');
                  modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS'
                    ? startGroupPresentation()
                    : startManuallyPresentation();
                }}
                className="bg-[rgba(67,160,71,1)] h-14 w-[40%] rounded-full border-[2px] border-white mt-4 mb-10"
              >
                <Text className="text-white text-sm font-bold">Start Presentation</Text>
              </Button>
            )} */}
            {profileData?.email === myEmailInPresentation?.participant_email && (
              <div className="w-full flex justify-center mb-5 z-[50]">
                <button
                  onClick={() => {
                    console.log('start presentation');
                    modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS'
                      ? startGroupPresentation()
                      : startManuallyPresentation();
                  }}
                  className="
                  flex items-center justify-center gap-2 px-2
                  border border-white text-white rounded-[43px]
                  bg-gradient-to-br from-[#2F3339] to-[#15181C]
                  shadow-custom-deep
            
                  h-8 w-36     
                  tablet:h-8 tablet:w-36
                  laptop:h-8 laptop:w-36
                  desktop:h-8 desktop:w-36
                  largescreen:h-8 largescreen:w-36
                  xxl:h-8 xxl:w-36
                "
                >
                  <Text as="span" size="2" weight="bold" className="text-s text-white">
                    Start Presentation
                  </Text>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_6083_4834)">
                      <path
                        d="M1.33203 1.33398H14.6654M5.33203 14.6673L7.9987 13.334M7.9987 13.334V11.334M7.9987 13.334L10.6654 14.6673M3.93203 11.334H12.0587C13.3254 11.334 13.992 10.6673 13.992 9.40065V1.33398H1.99203V9.40065C1.9987 10.6673 2.66536 11.334 3.93203 11.334Z"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5 7.33398L7.1 5.58065C7.26667 5.44065 7.48667 5.48065 7.6 5.66732L8.4 7.00065C8.51333 7.18732 8.73333 7.22065 8.9 7.08732L11 5.33398"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6083_4834">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            )}
          </div>
        );
      case 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS1':
        return (
          <Box className="flex flex-col items-center h-full  relative">
            {/* <div className="w-full flex justify-center z-50 my-5">
              <div className="bg-[rgba(33,32,37,0.8)] w-full rounded-lg py-1 px-4 border border-[rgba(84,84,85,1)] flex items-center justify-center">
                <Text as="span" size="2" weight="bold" className="text-[rgba(233,190,80,1)]">
                  Group Discussion debrief in progress
                </Text>
                <div className="w-[3vw]" />
                <div className="h-[1.1vh] w-[1.1vh] rounded-full bg-[rgba(67,160,71,1)] border border-[rgba(233,190,80,1)]" />
              </div>
            </div> */}
            {/* <Box className="absolute top-1 w-full flex justify-center">
              <Flex
                align="center"
                justify="center"
                className="bg-[rgba(33,32,37,0.8)] w-[55%] rounded-lg py-2 px-4 border-[2px] border-[rgba(84,84,85,1)]"
              >
                <Text className="text-[#E9BE50] text-sm font-bold">Group Discussion debrief in progress</Text>
                <Box className="w-3" />
                <Box className="h-3 w-3 rounded-full bg-[rgba(67,160,71,1)] border-[2px] border-[rgba(233,190,80,1)]" />
              </Flex>
            </Box> */}
            <div className="ml-auto me-4 mobile:ml-0 mobile:me-0 mobile:order-2 mobile:w-full mobile:flex mobile:justify-center">
              <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
                <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
                <div className="flex flex-row items-center justify-center gap-1">
                  <span className="text-[#E9BE50] text-[10px]">{pminutes}m</span>
                  <span className="text-[#E9BE50] text-[10px]">{pseconds}s</span>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col h-full justify-start my-5">
              <Box className="grid grid-cols-3 tablet:grid-cols-3 laptop:grid-cols-4 mobile:grid-cols-2 text-white mobile:gap-y-4 mobile:gap-0 gap-2 m-2">
                {manuallySelected?.seats?.map((item: any, index: number) => (
                  <Box key={item.id}>
                    <TableElementNew
                      hideKebab={true}
                      elementStyle={{
                        borderWidth: 1,
                        borderRadius: 1,
                        borderColor: '#D3D3D3',
                        marginVertical: 0.4,
                      }}
                      onPress={() => { }}
                      userData={item}
                      isExpandedView={true}
                      groupLeaderEmail={undefined}
                    />
                  </Box>
                ))}
              </Box>
            </div>
            {/* {profileData?.email !== manuallySelected?.seats[0]?.participant_email && (
              <Box><MyView roomClient={roomClient} /></Box>
            )} */}
            {/* {profileData?.email === myEmailInPresentation?.participant_email && (
              <Button
                onClick={() => {
                  console.log('start presentation');
                  modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS'
                    ? startGroupPresentation()
                    : startManuallyPresentation();
                }}
                className="bg-[rgba(67,160,71,1)] h-14 w-[40%] rounded-full border-[2px] border-white mt-4 mb-10"
              >
                <Text className="text-white text-sm font-bold">Start Presentation</Text>
              </Button>
            )} */}
            {profileData?.email === myEmailInPresentation?.participant_email && (
              <div className="w-full flex justify-center mb-5 z-[50]">
                <button
                  onClick={() => {
                    console.log('start presentation');
                    modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS'
                      ? startGroupPresentation()
                      : startManuallyPresentation();
                  }}
                  className="
                  flex items-center justify-center gap-2 px-2
                  border border-white text-white rounded-[43px]
                  bg-gradient-to-br from-[#2F3339] to-[#15181C]
                  shadow-custom-deep
            
                  h-8 w-36     
                  tablet:h-8 tablet:w-36
                  laptop:h-8 laptop:w-36
                  desktop:h-8 desktop:w-36
                  largescreen:h-8 largescreen:w-36
                  xxl:h-8 xxl:w-36
                "
                >
                  <Text as="span" size="2" weight="bold" className="text-s text-white">
                    Start Presentation
                  </Text>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_6083_4834)">
                      <path
                        d="M1.33203 1.33398H14.6654M5.33203 14.6673L7.9987 13.334M7.9987 13.334V11.334M7.9987 13.334L10.6654 14.6673M3.93203 11.334H12.0587C13.3254 11.334 13.992 10.6673 13.992 9.40065V1.33398H1.99203V9.40065C1.9987 10.6673 2.66536 11.334 3.93203 11.334Z"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5 7.33398L7.1 5.58065C7.26667 5.44065 7.48667 5.48065 7.6 5.66732L8.4 7.00065C8.51333 7.18732 8.73333 7.22065 8.9 7.08732L11 5.33398"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6083_4834">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            )}
          </Box>
        );
      case 'WHEN_GROUP_IS_PRESENTING':
        return (
          <div className="relative flex flex-col items-center desktop:h-[50vh] h-[50vh]  mobile:h-full w-full mobile:space-y-8">
            {/* {manuallySelected?.table_name && (
              <div
                className="absolute left-1/2 transform -translate-x-1/2 z-50 top-3 tablet:top-4 laptop:top-6 desktop:top-8 largescreen:top-10 xxl:top-12"
              >
                <div
                  className="text-white px-4 tablet:px-6 tablet:py-3 laptop:px-8 laptop:py-4 shadow-2xl flex items-center gap-2 text-xs tablet:text-base laptop:text-sm desktop:text-sm largescreen:text-md xxl:text-lg"
                >
                  <span>
                    {getGroupName(manuallySelected.table_name)} is Presenting
                  </span>
                </div>
              </div>
            )} */}
            {/* Main content container */}
            <div
              className={`w-full overflow-hidden gap-2 ${allStream[presentationOrder?.traineeDetails?.participant_email] ? 'flex flex-col mobile:h-fit justify-center mobile:justify-between desktop:flex-row largescreen:flex-row laptop:flex-row' : 'flex flex-col'} tablet:flex-1`}

            >
              {/* PeerView (Left side) */}
              {allStream[presentationOrder?.traineeDetails?.participant_email] && (
                <div className="mobile:w-full h-fit mobile:h-fit w-full max-w-5xl laptop:w-1/2 border border-[rgba(91,93,107,1)] flex items-center justify-center rounded-[1.5vh] overflow-hidden">
                  <div className="w-full h-full  rounded-[1.5vh] overflow-hidden relative">
                    <PeerView
                      caller="TableElement"
                      logicalMute={false}
                      style={{ height: 'mobile:h-[60vh]', width: '100%', position: 'relative', ObjectFit: 'cover' }}
                      streamURL={allStream[presentationOrder?.traineeDetails?.participant_email]}
                      peerEmail={presentationOrder?.traineeDetails?.participant_email}
                      allStream={undefined}
                      micIcon={true}
                      isExpandedView={false}
                      userDatax={presentationOrder?.traineeDetails}
                      height={390}
                    />
                    {/* Name & Mic */}
                    {/* <div className="h-[4vh] w-[40%]  absolute bottom-0 left-[30%] flex items-center justify-center rounded-md">
                                            <Text as="span" size="5" className="text-white text-center mr-[2vw]">
                                                {presentationOrder?.traineeDetails?.participant_name}
                                            </Text>
                                            <div className="h-[1.5vh] w-[1.5vh]">
                                                <img
                                                    src={mute ? mico : micoff}
                                                    alt="Mic Status"
                                                    className={`h-full w-full object-contain ${mute ? 'h-[80%] w-[80%]' : ''}`}
                                                    style={{ filter: 'brightness(0) invert(1)' }}
                                                />
                                            </div>
                                        </div> */}
                  </div>
                </div>
              )}

              {/* Table grid (Right side) */}
              <div
                className={`mobile:w-full largescreen:max-h-[50vh]  w-fit ${allStream[presentationOrder?.traineeDetails?.participant_email] ? 'laptop:w-1/2' : ''
                  } h-fit overflow-y-auto custom-scrollbar`}
              >
                <div className="h-full overflow-y-auto pr-2">
                  <div
                    className={`${allStream[presentationOrder?.traineeDetails?.participant_email] ? 'grid grid-cols-1' : 'grid grid-cols-6'} tablet:grid-cols-3 laptop:grid-cols-4 gap-2 m-2 text-white mobile:flex mobile:overflow-x-auto mobile:gap-4 mobile:px-2 mobile:pb-2 mobile:grid-cols-none mobile:grid-rows-none`}
                  >
                    {manuallySelected?.seats?.map((item) => {
                      if (item?.participant_email === removedEmail) return null;
                      return (
                        <div key={item.participant_id}>
                          <TableElementNew
                            elementStyle={{
                              borderWidth: 1,
                              borderRadius: 1,
                              borderColor: '#D3D3D3',
                              marginVertical: 0.4,
                            }}
                            onPress={() => { }}
                            userData={item}
                            isExpandedView={true}
                            hideKebab={true}
                            groupLeaderEmail={undefined}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* Fixed End Presentation Button */}
            {profileData?.email === removedEmail && (
              // <div className="absolute bottom-0 w-full flex justify-center pb-2">
              //     <button
              //         onClick={() => {
              //             EndPresentation();
              //         }}
              //         className="bg-[rgba(224,71,37,1)] h-[5.5vh] w-[40vw] flex items-center justify-center rounded-[2.75vh] border-[1px] border-white"
              //     >
              //         <Text as="span" size="2" weight="bold" className="text-white">
              //             End Presentation
              //         </Text>
              //     </button>
              // </div>
              <div className=" mobile:static absolute -bottom-10 w-full flex justify-center z-[50]">
                <button
                  onClick={() => {
                    EndPresentation();
                  }}
                  className="
      flex items-center justify-center gap-2 px-2
      border border-white text-white rounded-[43px]
      bg-gradient-to-br from-[#2F3339] to-[#15181C]
      shadow-custom-deep

      h-8 w-36     
      tablet:h-8 tablet:w-36
      laptop:h-8 laptop:w-36
      desktop:h-8 desktop:w-36
      largescreen:h-8 largescreen:w-36
      xxl:h-8 xxl:w-36
    "
                >
                  <Text as="span" size="2" weight="bold" className="text-s text-white">
                    Stop Presentation
                  </Text>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_6083_6290)">
                      <path d="M14.6654 1.83398H1.33203C1.0587 1.83398 0.832031 1.60732 0.832031 1.33398C0.832031 1.06065 1.0587 0.833984 1.33203 0.833984H14.6654C14.9387 0.833984 15.1654 1.06065 15.1654 1.33398C15.1654 1.60732 14.9387 1.83398 14.6654 1.83398ZM11.112 14.894C11.0254 15.0673 10.8454 15.1673 10.6654 15.1673C10.592 15.1673 10.512 15.1473 10.4454 15.114L7.9987 13.894L5.55203 15.114C5.48536 15.1473 5.40536 15.1673 5.33203 15.1673C5.15203 15.1673 4.97203 15.0673 4.88536 14.894C4.85479 14.8351 4.83639 14.7707 4.83127 14.7046C4.82616 14.6385 4.83443 14.572 4.85558 14.5091C4.87674 14.4463 4.91036 14.3883 4.95442 14.3388C4.99848 14.2892 5.05209 14.249 5.11203 14.2207L7.4987 13.0273V11.334H8.4987V13.0273L10.8854 14.2207C11.1387 14.3407 11.2387 14.6407 11.112 14.894Z" fill="#E9BE50" />
                      <path d="M2 1.33398V9.40065C2 10.6673 2.66667 11.334 3.93333 11.334H12.0667C13.3333 11.334 14 10.6673 14 9.40065V1.33398H2ZM11.32 5.72065L9.22 7.47398C9.02667 7.63398 8.78 7.70065 8.54667 7.66065C8.30667 7.62065 8.1 7.47398 7.97333 7.26065L7.27333 6.09398L5.32 7.72065C5.22667 7.80065 5.11333 7.83398 5 7.83398C4.89665 7.83461 4.79564 7.80319 4.71088 7.74404C4.62612 7.6849 4.56177 7.60095 4.52668 7.50373C4.49159 7.40651 4.4875 7.30081 4.51495 7.20117C4.54241 7.10153 4.60007 7.01284 4.68 6.94732L6.78 5.19398C6.97333 5.03398 7.22 4.96732 7.45333 5.00732C7.69333 5.04732 7.9 5.19398 8.02667 5.40732L8.72667 6.57398L10.68 4.94732C10.7307 4.90506 10.7892 4.87324 10.8522 4.85371C10.9153 4.83417 10.9815 4.82731 11.0472 4.8335C11.1129 4.8397 11.1767 4.85884 11.235 4.88982C11.2932 4.92079 11.3448 4.96299 11.3867 5.01398C11.56 5.22732 11.5333 5.54065 11.32 5.72065Z" fill="#E9BE50" />
                    </g>
                    <defs>
                      <clipPath id="clip0_6083_6290">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            )}
          </div>
        );
      case 'OPEN_CLASS_INTERACTION_IN_PROGRESS':
        return (<>
          {/* <div className="ml-auto me-4 mobile:ml-0 mobile:me-0 mobile:order-2 mobile:w-full mobile:flex mobile:justify-center">
            <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
              <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
              <div className="flex flex-row items-center justify-center gap-1">
                <span className="text-[#E9BE50] text-[10px]">{pminutes}m</span>
                <span className="text-[#E9BE50] text-[10px]">{pseconds}s</span>
              </div>
            </div>
          </div> */}
          <OpenClassInteraction roomClient={roomClient} minutesx={minutes} tableDetails={batchData?.participants} />
          {/* <Box className="h-full">
             <GdOpenClassInteraction batchData={batchData?.participants} minutesx={minutes} session_id={session_id} />
           </Box> */}
        </>
        );
      default:
        return <Box>{/* Default modal content */}</Box>;
    }
  };

  const renderOpenClassInteraction = () => {
    let _allParticipants = batchData?.participants;
    console.log('allParticipants', _allParticipants);

    let commonParticipants = _allParticipants?.filter((participant: any) => onlineStream.includes(participant?.email));
    if (commonParticipants?.length <= 2) {
      return (
        <Box>
          <Flex align="center" justify="center" className="bg-[#545455] w-[60%] rounded-lg h-10 top-[-130%] left-[20%]">
            <Text className="text-[#E9BE50] text-center">Role Play debrief in progress</Text>
            <Text className="text-green-500 text Kla2xl"> ●</Text>
          </Flex>
          <Box className="flex flex-col">
            {commonParticipants?.map((v: any, i: number) => (
              <Box key={i} className="flex-1">
                <Box><PeerView
                  style={{ flex: 1, height: '100%', width: '100%' }}
                  streamURL={allStream[v?.email]}
                /></Box>
                <Box className="absolute p-2">
                  <Text className="text-white">{v?.name || v?.participant_name}</Text>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      );
    } else {
      return (
        <Box className="grid grid-cols-3 gap-4">
          {commonParticipants.map((v: any, i: number) => (
            <Box key={i} style={{ height: boxSize.height, width: boxSize.width }}>
              <Box>
                <PeerView
                  style={{ flex: 1, height: '100%', width: '100%' }}
                  streamURL={allStream[v?.email]}
                /></Box>
              <Box className="absolute p-2 ml-[70%]">
                <Text className="text-white">{v?.name || v?.participant_name}</Text>
              </Box>
            </Box>
          ))}
        </Box>
      );
    }
  };

  const renderModalsDuringPresentation = () => {
    switch (modalMode) {
      case gdModalType.YOUNEXT:
        return (
          <Box className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            {/* <NotificationDuringPresentation
              imageIcon={Images.groupDiscussion}
              message="Your group presentation next ... in 02 minutes!"
              onClose={() => setModalMode(undefined)}
            /> */}
          </Box>
        );
      case gdModalType.TRAINER_HAS_EXTENDED_TIME:
        return (
          <Box className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            {/* <NotificationDuringPresentation
              imageIcon={Images.groupDiscussion}
              message="Trainer has extended your group presentation time."
              onClose={() => setModalMode(undefined)}
            /> */}
          </Box>
        );
      case gdModalType.WRAP_IN_TWO:
        return (
          <Box className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            {/* <NotificationDuringPresentation
              imageIcon={Images.groupDiscussion}
              message="You have 02 minutes to wrap up your presentation!"
              onClose={() => setModalMode(undefined)}
            /> */}
          </Box>
        );
      default:
        return <Box>{/* Default modal during presentation */}</Box>;
    }
  };

  const renderPresentParticipent = () => {
    let _otherParticipents = tblData?.seats?.filter(
      (x: any) => x?.participant_email?.toLowerCase() !== profileData?.email?.toLowerCase()
    );
    return (
      <Box className="flex flex-wrap">
        {_otherParticipents?.map((v: any, i: number) => (
          <Box key={i} className="w-[25vw] h-[25vw]">
            <PeerView
              caller='GroupDiscussion'
              logicalMute={false}
              style={{ flex: 1, height: '100%', width: '100%' }}
              streamURL={otherStream[v?.participant_email]}
            />
          </Box>
        ))}
        <Box className="flex flex-wrap">
          {['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) &&
            presentaionData?.presentNominee !== profileData?.email && (
              <PeerView
                caller='GroupDiscussion'
                logicalMute={false}
                style={undefined}
                streamURL={allStream[presentaionData?.presentNominee]}
              />
            )}
          <Box><Trainer name={trainer?.fullname} trainerTableName="On Table 1" /></Box>
          <Box><MyPeerView /></Box>
        </Box>
      </Box>
    );
  };

  const renderPresentationInGroups = () => (
    <Box className="flex-1 flex items-center justify-center">
      <ConfRoom isTrainerPresent={isTrainerPresent} roomClient={roomClient} table={tblData} name={tblData?.table_name} users={newTblData} gl={groupLeaderDetails} gdActivityData={GDActivityData} onBrief={onBrief} timer={GDAlotTime} />
    </Box>
  );

  if (isPresentationStarted && ['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) && showFullscreen) {
    return (
      <Box className="flex-1">
        {presentaionData?.activePresentation === 'share_whiteboard' && (
          <Box className="flex-1">
            <iframe
              src={`https://vtt.atwpl.com/whiteboard/boards/${session_id}?disableInteraction=${presentaionData?.presentNominee === profileData?.email ? false : true
                }`}
              className="w-full h-full"
              allow="camera; microphone; fullscreen; display-capture"
            />
          </Box>
        )}
        {presentaionData?.activePresentation === 'case_url' && (
          <Box className="flex-1">
            {presentaionData?.fileUrl?.endsWith('.pdf') ? (
              <iframe src={presentaionData?.fileUrl} className="w-full h-full" />
            ) : (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${presentaionData?.fileUrl}`}
                className="w-full h-full"
              />
            )}
          </Box>
        )}
        {presentaionData?.activePresentation === 'share_screen' && (
          <Box className="flex-1">
            <PeerView
              style={{ height: '100%', width: '100%' }}
              streamURL={shareStream}
            // key={new Date()}
            />
          </Box>
        )}
        <Box className="flex flex-wrap">
          {['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) &&
            presentaionData?.presentNominee !== profileData?.email && (
              <PeerView
                style={undefined}
                streamURL={allStream[presentaionData?.presentNominee]}
              // key={new Date()}
              />
            )}
          <Box><Trainer name={trainer?.fullname} trainerTableName="On Table 1" /></Box>
          <Box><MyPeerView /></Box>
        </Box>
      </Box>
    );
  }

  if (isPresentationStarted) {
    return (
      <Box className="flex-1">
        {!presentaionData?.activePresentation && (
          <PeerView
            style={undefined}
            streamURL={allStream[presentaionData?.presentNominee]}
          />
        )}
        {presentaionData?.activePresentation === 'share_whiteboard' && (
          <Box className="h-[70vh] w-[96vw] m-[2vw]">
            <iframe
              src={`https://vtt.atwpl.com/whiteboard/boards/${session_id}`}
              className="w-full h-full"
              allow="camera; microphone; fullscreen; display-capture"
            />
          </Box>
        )}
        {presentaionData?.activePresentation === 'case_url' && (
          <Box className="h-[70vh] w-[96vw] m-[2vw]">
            {presentaionData?.fileUrl?.endsWith('.pdf') ? (
              <iframe src={presentaionData?.fileUrl} className="w-full h-full" />
            ) : (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${presentaionData?.fileUrl}`}
                className="w-full h-full"
              />
            )}
          </Box>
        )}
        {presentaionData?.activePresentation === 'share_screen' && (
          <PeerView
            style={undefined}
            streamURL={shareStream}
          />
        )}
        <Flex align="center" className="bg-[#5F488A] px-4">
          <Text className="text-white font-bold">{tblData?.table_name}</Text>
          {presentaionData?.presentNominee === profileData?.email ? (
            <Button onClick={handleEndPresentation} className="flex-1 flex items-center">
              <Text className="text-white">Click to end Presentation</Text>
              <img src={exitPresentation} className="h-6 w-12" alt="exit" />
            </Button>
          ) : (
            <Box className="flex-1" />
          )}
          {/* <Button onClick={() => setShowMenu(!showMenu)}>
            <img src={Images?.vdots} className="h-8 w-10" alt="menu" />
          </Button> */}
          {showMenu && (
            <Box className="absolute top-8 right-0 bg-white p-4 rounded-lg shadow-lg">
              <Text onClick={() => setShowFullscreen(true)} className="cursor-pointer">
                Full Screen
              </Text>
            </Box>
          )}
        </Flex>
        {renderPresentParticipent()}
        {renderModalsDuringPresentation()}
      </Box>
    );
  }

  return (
    <div className="relative flex flex-col mobile:h-full h-full w-full">
      <div className='flex-1 relative h-full'>
        {modalMode && renderModalContent()}
        <div className="w-full">
          {/* {openClassInteraction ? renderOpenClassInteraction() : !modalMode && renderPresentationInGroups()} */}
          {openClassInteraction ? renderOpenClassInteraction() : null}
          {!openClassInteraction && !modalMode ? renderPresentationInGroups() : null}
        </div>
        <div
          className={`absolute inset-0 flex justify-center items-center mobile:items-end mobile:justify-center pointer-events-none ${extendedTime.visible ? 'opacity-100' : 'opacity-0'
            }`}
        >
          <div className="pointer-events-auto w-[40%] mobile:w-full h-[16%] bg-[#24272C] rounded-lg p-5 shadow-lg mb-4 mobile:mb-2">

            <Text className="text-white font-bold text-center">
              Trainer has extended discussions duration by {extendedTime.time} mins.
            </Text>
          </div>
        </div>
        <div
          className={`absolute inset-0 flex justify-center items-center mobile:items-end mobile:justify-center pointer-events-none ${isTwoMinutesLeft ? 'opacity-100' : 'opacity-0'
            }`}
        >
          <div className="pointer-events-auto w-[40%] mobile:w-full h-[16%] bg-[#24272C] rounded-lg p-5 shadow-lg mb-4 mobile:mb-2">
            <Text className="text-white font-bold text-center">Group Discussion ends in 2 mins!</Text>
          </div>
        </div>
      </div>
      <BottomMessage visible={false} />
      <BottomMessageWithIcon
        message={messageCxt.message}
        visible={messageCxt.visible}
        onClose={() => setMessageCxt({ visible: false, message: '' })}
      />
    </div>
  );
};

export default GroupDiscussion;